import {
  Box,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import * as React from "react";

import { EditFieldButton } from "@/shared/components/EditFieldButton";
import {
  TriggerEvaluationCause,
  causeToFormattedString,
} from "@/shared/domain/actions";
import { UpdateTriggerRequest } from "@/shared/domain/actions/TriggerRecord";

import { TriggerCauseSelector } from "./TriggerCauseSelector";

interface EditableTriggerCausesProps {
  value: TriggerEvaluationCause[];
  onChange: (updates: UpdateTriggerRequest) => void;
  setErrorText: (error: string) => void;
}

export const EditableTriggerCauses: React.FC<EditableTriggerCausesProps> = ({
  value,
  onChange,
  setErrorText,
}) => {
  const theme = useTheme();
  const [showEditableIcon, setShowEditableIcon] = React.useState(false);
  const [editable, setEditable] = React.useState(false);
  const [causes, setCauses] = React.useState(value);
  const readableCauses = causes?.map(causeToFormattedString) || [];

  const updateRecord = (newCauses: TriggerEvaluationCause[]) => {
    setErrorText("");

    onChange({
      causes: newCauses,
    });
  };

  const onClick = () => {
    if (editable) {
      updateRecord(causes);
    }
    setEditable(!editable);
  };

  return (
    <ListItem
      onMouseOver={() => {
        setShowEditableIcon(true);
      }}
      onMouseLeave={() => {
        setShowEditableIcon(false);
      }}
    >
      <ListItemText
        primaryTypographyProps={{
          component: "span",
        }}
        sx={{
          mt: theme.spacing(0.5),
        }}
        primary={
          <>
            <span>Trigger On</span>

            <EditFieldButton
              editable={editable}
              showEditableIcon={showEditableIcon}
              onClick={() => {
                void onClick();
              }}
            />

            <Box>
              {editable === false ? (
                <Typography
                  component="span"
                  variant="body2"
                  style={{
                    whiteSpace: "pre-wrap",
                    color: theme.palette.text.secondary,
                  }}
                >
                  {readableCauses.length > 0
                    ? `${readableCauses.join(", ")}`
                    : "Never"}
                </Typography>
              ) : (
                <Box
                  sx={{
                    mt: theme.spacing(1),
                  }}
                >
                  <TriggerCauseSelector causes={causes} setCauses={setCauses} />
                </Box>
              )}
            </Box>
          </>
        }
      />
    </ListItem>
  );
};
